<template>
  <FormField
    :id="id"
    v-slot="{ hasErrorState }"
    :label="label"
    :description="description"
    :col-span-class="colSpanClass"
    :errors="errors"
    :disabled="disabled"
    :has-hidden-label="hasHiddenLabel">
    <select
      :id="id"
      :name="name"
      :autocomplete="autocomplete"
      :required="required"
      :disabled="disabled"
      class="pf-select shadow-sm block w-full sm:text-sm rounded-md transition-colors duration-200 ease-in-out disabled:bg-grey-100 disabled:text-grey-700 dark:bg-grey-900 dark:disabled:bg-grey-700 dark:disabled:text-grey-300"
      :class="
        hasErrorState
          ? 'text-red-900 border-red-300 placeholder-red-300 focus:ring-red-500 focus:border-red-500 dark:text-red-400 dark:border-red-800 dark:placeholder-red-600'
          : 'text-grey-900 border-grey-300 focus:ring-primary-500 focus:border-primary-500 placeholder-grey-500 dark:text-grey-200 dark:border-grey-700 dark:placeholder-grey-400'
      "
      :aria-label="hasHiddenLabel ? label : null"
      :aria-invalid="hasErrorState"
      :aria-errormessage="hasErrorState ? `${id}-error` : null"
      :aria-describedby="description ? `${id}-description` : null"
      v-bind="$attrs"
      @input="
        (v) => {
          $emit('update:modelValue', v.target.value);
        }
      ">
      <option v-if="placeholder" value="" selected hidden>
        {{ placeholder }}
      </option>
      <option v-for="option in options" :key="option" :value="option.value" :selected="option.value === modelValue">
        {{ option.label }}
      </option>
    </select>
  </FormField>
</template>

<script>
import FormField, { commonFieldProps } from "../field/index";

export default {
  components: {
    FormField
  },
  props: {
    ...commonFieldProps,
    modelValue: {},
    placeholder: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    hasHiddenLabel: Boolean
  }
};
</script>
